module.exports = __webpack_public_path__ + "static/img/2018ltyj2.ed34733.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsDetail/images/2018ltyj2.jpg
// module id = hf8u
// module chunks = 0